{
  "mappings": [
    {
      "category": "Account Information",
      "titles": ["Account", "user.json", "user_data.json", "data_subject_access_requests.json"]
    },
    {
      "category": "User-Generated Content",
      "titles": [
        "Messages",
        "message.txt",
        "Activities",
        "Activities_1",
        "Activities_2",
        "Activity",
        "Servers",
        "Support_Tickets",
        "discord_harvests",
        "traits.json",
        "user_data.json",
        "user_data_exports"
      ]
    },
    {
      "category": "Payment Information",
      "titles": [
        "billing_profile.json",
        "discord_billing",
        "payment_sources.json",
        "payments.json",
        "coin_accounts.json",
        "coin_transactions.json",
        "discord_store",
        "quests_reward_codes.json",
        "drops_reward_codes.json",
        "wishlist_items.json"
      ]
    },
    {
      "category": "Usage Data",
      "titles": [
        "Activities",
        "Activities_1",
        "Activities_2",
        "Activity",
        "Servers",
        "discord_promotions",
        "events-2026-00000-of-00001.json",
        "entitlements.json",
        "quests_user_status.json",
        "tns"
      ]
    },
    {
      "category": "Device and Usage Information",
      "titles": ["README.txt", "reporting", "tns", "events-2026-00000-of-00001.json"]
    },
    {
      "category": "Third-Party and Cookie Information",
      "titles": ["no_matching_file"]
    }
  ]
}
